"use client";

import clsx from "clsx";
import { useTranslations } from "@/lib/compat/i18n";

const CHANNELS = [
  { key: "email",    glyph: "@",  labelKey: "channelEmail"    },
  { key: "whatsapp", glyph: "✉",  labelKey: "channelWhatsapp" },
  { key: "sms",      glyph: "✆",  labelKey: "channelSms"      },
] as const;

/**
 * Screen 0.2 — Outreach-channel picker. Centred over Al Madar's discovery
 * view. Al Madar (just landed on Aurora's public listing via Google in
 * 0.1) picks how to make first contact. Email is the default — the
 * sequel screens 0.3 + 0.4 carry the email thread.
 */
export function ShareModal({
  picked = "email",
  className,
}: {
  picked?: typeof CHANNELS[number]["key"];
  className?: string;
}) {
  const t = useTranslations("shareModal");
  return (
    <div className={clsx("absolute inset-0 z-30 flex items-center justify-center bg-orbitra-ink/55 backdrop-blur-sm", className)}>
      <div className="glass w-[480px] p-6 shadow-glass">
        <p className="font-mono text-[9px] uppercase tracking-[0.18em] text-orbitra-teal-soft">{t("reachOutKicker")}</p>
        <h2 className="mt-1 font-display text-lg font-semibold text-orbitra-paper">{t("reachOutTitle")}</h2>
        <p className="mt-1 text-[12px] text-orbitra-teal-soft">
          {t("reachOutSubtitle")}
        </p>

        <div className="mt-5 grid grid-cols-3 gap-2">
          {CHANNELS.map((c) => {
            const isPicked = c.key === picked;
            return (
              <div
                key={c.key}
                className={clsx(
                  "flex flex-col items-center gap-1 rounded-md border px-2 py-3 transition-state",
                  isPicked
                    ? "border-state-verified bg-state-verified/15 text-state-verified shadow-[0_0_18px_var(--state-verified-glow)]"
                    : "border-orbitra-muted/30 text-orbitra-muted",
                )}
              >
                <span className="font-display text-base">{c.glyph}</span>
                <span className="text-[10px] uppercase tracking-wider">{t(c.labelKey)}</span>
              </div>
            );
          })}
        </div>

        <div className="mt-5 rounded-md border border-state-verified/30 bg-orbitra-ink/60 p-3 font-mono text-[11px] text-orbitra-teal-soft">
          {t("sellerEmail")}
        </div>
      </div>
    </div>
  );
}
